module.exports = __webpack_public_path__ + "static/sport/img-title.1165b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/img-title.png
// module id = DNBo
// module chunks = 0